import LazyLoad from "vanilla-lazyload";

export const initLazyload = () => {
    new LazyLoad({
        elements_selector: "[data-lazy]",
        use_native: true,
    });
};
